import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import apiClient from '../../Api/apiClient';

const ForgotPasswordOTP = ({ onSignUp, onLogin }) => {
  const location = useLocation();
  const { phone, forgotFromAffiliator } = location.state || {}; // Access the phone number from state
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(180); // 3 minute countdown
  const [canResend, setCanResend] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (otp.join('').length !== 4)
      newErrors.otp = 'Please provide a 4-digit OTP';
    return newErrors;
  };

  const handleChange = (e, index) => {
    const value = e.target.value;

    // Only allow numeric values
    if (/^[0-9]$/.test(value) || value === '') {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically focus on the next input field
      if (value !== '' && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      // Move focus to the previous input on Backspace
      inputRefs.current[index - 1].focus();
    }
    if (e.key === 'Enter') {
      handleOTP();
    }
  };

  // console.log(phone);

  const handleOTP = async () => {
    const otpString = otp.join(''); // Ensure OTP is formatted as a string
    console.log('otpString and phone:', phone, otpString);

    const otpBody = {
      otp: otpString,
      phone,
    };

    // console.log('before send otp body:', otpBody);

    try {
      let url = '/auth/user/verify-forget-otp';
      if (forgotFromAffiliator) {
        url = '/auth/affiliator/verify-forget-otp';
      }
      const response = await apiClient.patch(url, otpBody, {
        withCredentials: true,
      });
      console.log('OTP send:', response.data);
      // // Step 3: Extract response data
      // const {
      //   token: bearer,
      //   data: { otp_status },
      // } = response.data;
      // console.log('OTP Status:', otp_status);

      // // Step 4: Store token in localStorage
      // localStorage.setItem('bearer', bearer);
      // onLogin();
      navigate('/newPassword', {
        state: { phone: phone, forgotFromAffiliator: forgotFromAffiliator },
      });
      // navigate('/newPassword');
    } catch (error) {
      console.error('OTP verification failed:', error);
      const errorMessage = error.response?.data?.message;
      Swal.fire({
        title: 'Verify Failed!',
        // text: 'An error occurred while resending OTP. Please try again.',
        text: errorMessage,
        confirmButtonText: 'Retry',
        customClass: {
          popup: 'w-80 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      if (error.response) {
        console.log('Server responded with:', error.response.data);
      } else {
        console.log('An unexpected error occurred.');
      }
    }
  };

  const handleResendOTP = async () => {
    setTimer(180); // Reset timer to 3 minutes
    setCanResend(false); // Disable resend button
    // console.log('phone:', phone);

    try {
      let url = '/auth/user/resend-otp';
      if (forgotFromAffiliator) {
        url = '/auth/affiliator/resend-otp';
      }
      const response = await apiClient.post(
        // '/auth/user/resend-otp',
        url,
        { phone },
        { withCredentials: true }
      );
      console.log(response);
      const succesMessage = response.data.message;
      Swal.fire({
        title: 'OTP Resent',
        // text: 'A new OTP has been sent to your registered mobile number.',
        text: succesMessage,
        confirmButtonText: 'Okay',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });
      // Swal.fire({
      //   title: 'OTP Resent',
      //   text: 'A new OTP has been sent to your registered mobile number.',
      //   confirmButtonText: 'Okay',
      //   customClass: {
      //     popup: 'w-72 h-auto p-3',
      //     title: 'text-lg',
      //     content: 'text-xs',
      //     confirmButton:
      //       'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
      //   },
      // });
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      Swal.fire({
        title: 'Resend Failed',
        // text: 'An error occurred while resending OTP. Please try again.',
        text: errorMessage,
        confirmButtonText: 'Retry',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      console.error('Error resending OTP:', error);
    }
  };

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setCanResend(true); // Allow resend after countdown
    }
  }, [timer]);

  useEffect(() => {
    if (canResend) {
      // Optionally show a message or change the button text to indicate the user can resend OTP
    }
  }, [canResend]);

  return (
    <div className="flex bg-EntryBG items-center justify-center min-h-screen md:py-16 py-24 md:mt-10 mt-16 px-2 ">
      <div className="bg-white p-10 items-center justify-center flex flex-col lg:flex-row gap-10 shadow-xl rounded-xl">
        {/* left section */}
        <div>
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className=" h-10 lg:h-16 mb-0 md:pl-8 lg:mb-0"
          />
          <img src={LoginImg} alt="LoginImg" className="md:h-40 h-32 " />
        </div>

        {/* right section */}
        <div className="">
          <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-4">
            OTP
          </h2>

          <div className="w-full space-y-4 mt-2">
            {/* Input Fields */}
            <div className="flex space-x-4 items-center justify-center">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={el => (inputRefs.current[index] = el)} // Store references to each input
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={e => handleChange(e, index)}
                  onKeyDown={e => handleKeyDown(e, index)}
                  className="w-12 h-12 text-center text-2xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              ))}
            </div>
            {errors.otp && (
              <p className="text-red-500 text-xs text-left mb-0 -mt-2">
                {errors.otp}
              </p>
            )}

            {/* Resend OTP Button */}
            <div className="text-right mt-4">
              <button
                onClick={handleResendOTP}
                className={`text-red-600  ${
                  canResend ? '' : 'opacity-50 cursor-not-allowed'
                }`}
                disabled={!canResend}
              >
                {canResend
                  ? 'Resend OTP'
                  : `Resend OTP in ${Math.floor(timer / 60)}:${(
                      '0' +
                      (timer % 60)
                    ).slice(-2)}`}
              </button>
            </div>

            {/* Button */}
            <button
              onClick={handleOTP}
              disabled={loading}
              className={`w-full bg-EntryBG text-white py-2 px-6 mb-2 mt-2 rounded-2xl ${
                loading ? 'cursor-not-allowed' : 'hover:bg-btnHover'
              }`}
            >
              {loading ? 'Verifying...' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordOTP;
